interface ErrorMessage {
    [key: number]: string;
}

export const ErrorMessages: ErrorMessage = {
    9: '12312312',
    10: 'An error occurred while processing your request. This may be due to an invalid session ID.',
    11: 'There is no valid Network Access resource configured, so the network access connection cannot start.',
    12: 'The client’s IP address changed while the session was in progres',
    13: 'The browser User-Agent is not supported.',
    14: 'The maximum number of concurrent user sessions has been reached. No new user sessions can start at this time.',
    15: 'The session has been terminated.',
    16: 'The system is currently undergoing maintenance. Please try to connect again later.',
    17: 'Access was denied by an access control list.',
    18: 'The session cannot start because a configuration element is not licensed. Please contact you system administrator for more information.',
    19: 'BIG-IP can not find session information in the request. This can happen because your browser restarted after an add-on was installed. If this occurred, click the link below to continue. This can also happen because cookies are disabled in your browser. If so, enable cookies in your browser and start a new session.',
    20: 'Invalid Session ID. Your session may have expired.',
    21: 'Invalid Nonce',
    22: 'Access policy configuration has changed on gateway. Please login again to comply with new access policy configuration',
    23: 'Access was denied by a per-request policy.',
    24: 'Access to this page is blocked.',
    25: 'Your session has expired.',
    26: 'The ephemeral authentication feature is not licensed. Please contact your system administrator for more information.',
    27: 'Configuration error. Webtop configuration is required for ephemeral authentication. Contact your system administrator for assistance.',
};
